//@DEPRECATED
import { FC, useMemo } from 'react';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { styled } from '@mui/system';

import { WordBreak } from 'src/components';
import { TAIForm, ISummary, IMaterial } from 'src/types';
import { formatDate } from 'src/utils';
import { getFileLink } from 'src/utils';


const MaterialList = styled('ul')`
  list-style: none;
  padding-left: 8px;
`;

interface AttachmentListProps {
  data: ISummary | TAIForm;
  fieldPath?: string;
}

const handleMaterialClick = async (material: IMaterial) => {
  const url = await getFileLink(material);
  window.open(url, "_blank");
};


const AttachmentList: FC<AttachmentListProps> = ({ data, fieldPath }) => {
  const materialsList = useMemo(() => {
    const materials: IMaterial[] = data?.materials as IMaterial[] || [];
    return materials.filter((each) => {
      if (!fieldPath) {
        return !each.fieldPath;
      } else {
        return each.fieldPath === fieldPath;
      }
    });
  }, [data?.materials, fieldPath]);

  return (
    <MaterialList>
      {materialsList?.map((material: any, i: number) => (
        <li className="display-flex align-items-xs-center" key={material.fileName + material.updateDate + fieldPath + i}>
          <AttachFileIcon />
          <div>
            <a
                key={material.s3key}
                href="#"
                onClick={e => {
                  e.preventDefault();
                  handleMaterialClick(material);
                }}
            >
              {material.fileName}
            </a>

            <WordBreak>
              <WordBreak>{material.description}</WordBreak>
              <WordBreak>Uploaded: {formatDate(material.updateDate)}</WordBreak>
            </WordBreak>
          </div>
        </li>
      ))}
    </MaterialList>
  );
};

export default AttachmentList;
